import React, {useState} from 'react';
import { useAppSelector} from "../DAL/store";
import {useWindowSize} from "../../../../domain/common";
import {MOBILE_BREAKPOINT, TABLET_BREAKPOINT_END} from "../../../../domain/animations/animations-provider";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";

/**
 * the entry point
 */
const App: React.FC = () => {


    const AllTagsData = useAppSelector((store) => store.AllTagsData);
    const [selectedTagGroup,setSelectedTagGroup] = useState(AllTagsData.tagCategories.length > 0 ? AllTagsData.tagCategories[0] : null);
    const selectedGroupTags = selectedTagGroup !== null ? AllTagsData.tags.filter(tag => tag.categoryID === selectedTagGroup.categoryID) : [];
    const size = useWindowSize();

    //sort a-z inside column
    const getGridStyle = (itemNumber : number) => {
        let columnNumber = (size.width !== undefined && size.width < MOBILE_BREAKPOINT) ? 1 :((size.width !== undefined && size.width < TABLET_BREAKPOINT_END) ? 2 : 3 );
        return {gridTemplateRows:"repeat("+Math.ceil(itemNumber / columnNumber)+", 32px)",gridAutoFlow:"column",listStyle:"none"}
    }

    return (
        <div className="waves-box-lg mx-auto px-5 md:px-12 mt-8">
            <ul className="w-full" >
                {AllTagsData.tagCategories.map((tagCategory,index) => {
                    return <li className="w-fit float-left pb-2 lg:pb-10" key={index}>
                        <div onClick={() => setSelectedTagGroup(tagCategory)}
                             className={`${selectedTagGroup !== null && selectedTagGroup.categoryID === tagCategory.categoryID ? "bg-blue-200 text-white" : "bg-gray-150 text-gray-700"} flex text-sm py-4 px-6 mr-2 cursor-pointer rounded no-underline`}>
                            {tagCategory.category}
                        </div>
                    </li>
                })
                }
            </ul>

            {selectedTagGroup !== null && <div key={selectedTagGroup.categoryID} className="">
                    <div className="w-full grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-flow-row pt-8 lg:pt-0"
                         style={getGridStyle(selectedGroupTags.length)}>
                        {selectedGroupTags.map((tag,index) => {
                            return <div className="grid-item" key={tag.categoryID + "_" + index} >
                                <a className="text-gray-500 no-underline"
                                   onClick={(evt) => {
                                       sendGAEvent('Click', "Tag: " + tag.tagAlias);
                                   }}
                                   href={selectedTagGroup.baseURL+tag.tagAlias }>
                                    {tag.tagName + " (" +tag.presetCount.toString() +")"}
                                </a>
                            </div>
                        })}
                    </div>
                </div>
            }
        </div>


    );
};

export default App;

